import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  position: {
    id: 'app.containers.ApplicantDrawerPopup.resumeReview.position',
    defaultMessage: '{position, number} of {total, number}',
    description: 'Applicant position within the fixed resume review list',
  },
  universalApplicantView: {
    id: 'app.containers.ApplicantDrawerPopup.resumeReview.universalApplicantView',
    defaultMessage: 'Universal Applicant View',
    description: 'Name of the applicant list across openings',
  },
});
